import * as React from 'react';
const PrivateContext = /*#__PURE__*/React.createContext({});
export default PrivateContext;